import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { HistoricalMovement } from '../historical-movement';
import { ToolCategoryBuilder } from './tool-category.builder';
import { UserBuilder } from './user.builder';

export class HistoricalMovementBuilder {
  static fromJson(json) {
    return (json)
      ? new HistoricalMovement(
        json.hash,
        json.toolName,
        json.toolErpName,
        json.isHolder,
        json.rebuildToolName,
        json.rebuildToolErpName,
        parseNumber(json.date),
        parseNumber(json.quantity),
        json.sent,
        json.type,
        ToolCategoryBuilder.fromJson(json.toolCategory),
        UserBuilder.fromJson(json.user)
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ?
      sortByNumber('date', mapCollection(HistoricalMovementBuilder.fromJson, list)) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/historical-movement.builder.ts